// extracted by mini-css-extract-plugin
export var divider = "_fa-7";
export var itemsToggle = "_fa-8";
export var mergeModal = "_fa-1";
export var optionCard = "_fa-4";
export var radioGroup = "_fa-6";
export var radioOption = "_fa-0";
export var selected = "_fa-5";
export var shipmentOptions = "_fa-2";
export var tableOptions = "_fa-3";